<div class="container-fluid py-3">
    <h1>{{ 'properties_api_tokens' | translate: 'online' : 'systems' }}</h1>
    <p class="text-secondary">
        {{ 'user_api_tokens_description' | translate }}
    </p>
    @if (user$ | async; as user) {
        @if (user.debtorNo != null) {
            <p class="text-secondary">{{ 'user_debtorno_info' | translate }} {{ user.debtorNo }}</p>
        }
    }
    @if (apiTokens$ | async; as apiTokens) {
        <div class="text-end">
            <button type="button" class="btn btn-primary" (click)="createApiToken()">
                {{ 'titles_create' | translate: 'online' : 'systems' }}
            </button>
        </div>

        @if (apiTokens.length > 0) {
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>{{ 'properties_token_name' | translate: 'online' : 'systems' }}</th>
                            <th>{{ 'properties_token' | translate: 'online' : 'systems' }}</th>
                            <th>{{ 'properties_createDate' | translate: 'online' : 'systems' }}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        @for (token of apiTokens; track $index) {
                            <tr>
                                <td>{{ token.tokenName }}</td>
                                <td>{{ token.tokenPartial }}&hellip;</td>
                                <td>{{ token.createDate | appdate }}</td>
                                <td class="text-end">
                                    <button
                                        type="button"
                                        (click)="revokeToken(token)"
                                        class="btn btn-text-primary btn-sm">
                                        {{
                                            'properties_revoke_token'
                                                | translate: 'online' : 'systems'
                                        }}
                                    </button>
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>
        }
    }
</div>
